module.exports = __webpack_public_path__ + "img/brand-cases18.b325ea33.png";